/**
 * [state 状态]
 * userData 用户数据
 * 
 * [actions 事件派发]
 * SET_USERDATA 改变状态中的用户数据]
 * 
 * [mutations 状态变更]
 */

//封装过期控制代码
// const Storage = {
//   set: function(key, value) {
//     var curTime = new Date().getTime();
//     localStorage.setItem(key, JSON.stringify({
//       data: value,
//       time: curTime
//     }));
//   },
//   get: function(key, exp) {
//     var data = localStorage.getItem(key);
//     var dataObj = JSON.parse(data);
//     if(!dataObj){
//       return '';
//     }
//     if (exp && (new Date().getTime() - dataObj.time > exp)) {
//       console.log('信息已过期');
//     } else {
//       var dataObjDatatoJson = JSON.parse(dataObj.data)
//       return dataObjDatatoJson;
//     }
//   },
// }

const storeData = {
  userData: JSON.parse(window.localStorage.getItem('userData')),
  organization: JSON.parse(window.localStorage.getItem('organization')),

  // 会过期
  // projectTable: Storage.get('projectTable', 1000 * 60 * 60),
}

export default {
  state: {
    mainType: "index",
    subType: "",
    nowRouterUrl: "/",
    // 审批
    approval_row: {}, // 整个对象
    approvalId: 0,
    approvalType: 0,
    approvalSuccess: false,
    
    // projectTable: storeData.projectTable ? storeData.projectTable : {
    //   status: false,
    //   applyId: 1,
    //   tableType: 0,
    //   project: {},
    // },
    projectTable: {
      status: false,
      applyId: 1,
      tableType: 0,
      project: {},
    },
    // 工程项目
    projectReload: false,

    // contact
    contactCurNode: {},
    contactShow: false,
    contactSelectArr: [],
    contactSingleSelect: true,
    contactApprovalDep: 0,
    contactType: '',
    // 判断是否是审批人员选择
    contactApprovalItem: true,

    // 用户数据
    userData: storeData.userData ? storeData.userData : '',

    // 组织树列表
    organization: storeData.organization ? storeData.organization : '',
    employeeList: [],

    // 与我相关消息数目
    tipNum: {},


    // 是否手机版
    isMobile: false,

    // 打印数据
    printData: {
      type: '',
      data: '',
      isPrint: false,
    }
  },
  mutations: {
    // 设置审批时的列表的row数据
    set_approval_row(state, val) {
      state.approval_row = val
    },

    // 设置打印数据
    set_printData(state, val) {
      state.printData = val
    },

    set_tipNum(state, val) {
      state.tipNum = val
    },

    set_projectDetailRefresh(state, val) {
      state.projectDetailRefresh = val
    },
    set_contactType(state, val) {
      state.contactType = val
    },
    set_isMobile(state, val) {
      state.isMobile = val
    },
    set_projectReload(state, val) {
      state.projectReload = val
    },
    set_projectTable(state, val) {
      // if (val) {
      //   Storage.set('projectTable', JSON.stringify(val))
      // } else {
      //   window.localStorage.removeItem('projectTable')
      // }
      state.projectTable = val
    },
    set_contactSingleSelect(state, val) {
      state.contactSingleSelect = val
    },
    set_contactApprovalItem(state, val) {
      state.contactApprovalItem = val
    },
    set_approvalType(state, val) {
      state.approvalType = val
    },
    set_approvalSuccess(state, val) {
      state.approvalSuccess = val
    },
    set_approvalId(state, val) {
      state.approvalId = val
    },
    set_contactApprovalDep(state, val) {
      state.contactApprovalDep = val
    },
    set_contactSelectArr(state, val) {
      state.contactSelectArr = val
    },
    set_contactShow(state, val) {
      state.contactShow = val
    },

    set_employeeList(state, val) {
      state.employeeList = val
    },
    set_organization(state, val) {
      if (val) {
        window.localStorage.setItem('organization', JSON.stringify(val))
      } else {
        window.localStorage.removeItem('organization')
      }
      state.organization = val
    },
    set_userData(state, val) {
      if (val) {
        window.localStorage.setItem('userData', JSON.stringify(val))
      } else {
        window.localStorage.removeItem('userData')
      }
      state.userData = val
    },

    set_contactCurNode(state, val) {
      state.contactCurNode = val
    },
    SET_TYPE(state, val) {
      state.mainType = val.main
      state.subType = val.sub
    },
    SET_ROUTER_URL(state, val) {
      state.nowRouterUrl = val
    }
  },
  actions: {}
}



// WEBPACK FOOTER //
// ./src/store/main.js